/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Note = {
    /**
     * ID of the note
     */
    id: string;
    /**
     * ID of the workspace
     */
    workspaceId: string;
    /**
     * ID of the project
     */
    projectId: string;
    title: string;
    content: string;
    createdBy: string;
    ownerId: string;
    lastEditedBy: string;
    status: Note.status;
    visibility: Note.visibility;
    tags: Array<string> | null;
    guests: Array<string> | null;
    versionId: string | null;
    parent: {
        type: Note.type;
        id: string;
    };
    created: string;
    updated: string;
    _object: Note._object;
};
export namespace Note {
    export enum status {
        DRAFT = 'draft',
        PUBLISHED = 'published',
        ARCHIVED = 'archived',
    }
    export enum visibility {
        PUBLIC = 'public',
        PRIVATE = 'private',
        UNLISTED = 'unlisted',
        WORKSPACE = 'workspace',
        WORKSPACE_AND_GUESTS = 'workspace_and_guests',
        PRIVATE_AND_GUESTS = 'private_and_guests',
        CUSTOM = 'custom',
        INTERNAL = 'internal',
    }
    export enum type {
        WORKSPACE = 'workspace',
        NOTE = 'note',
    }
    export enum _object {
        NOTE = 'note',
    }
}

